// @flow
import type { Action, State } from './types';

const initialState: State = {
  promos: {
    fetching: false,
    error: false,
    content: [],
    requestId: 0,
  },
  recommendations: {
    fetching: false,
    error: false,
    content: [],
    requestId: 0,
  },
  most_popular: {
    fetching: false,
    error: false,
    content: [],
    requestId: 0,
  },
  recently_watched: {
    fetching: false,
    error: false,
    content: [],
    requestId: 0,
  },
  live_channels: {
    fetching: false,
    error: false,
    content: [],
    requestId: 0,
  },
  view_all: {
    fetching: false,
    error: false,
    content: [],
    requestId: 0,
  },
};

const reducer = (state: State = initialState, action: Action): State => {
  switch (action.type) {
    case 'REQUEST_HOME_PAGE_CONTENT': {
      const { content } = state[action.category];
      return {
        ...state,
        [action.category]: {
          fetching: true,
          error: false,
          /* Keep results of previous fetches (this is to prevent home page flickering) */
          content,
          requestId: action.requestId,
        },
      };
    }
    case 'RESPONSE_HOME_PAGE_CONTENT':
      if (state[action.category].requestId !== action.requestId) return state;
      return {
        ...state,
        [action.category]: {
          ...state[action.category],
          fetching: false,
          error: false,
          content: action.payload ? action.payload : [],
        },
      };
    case 'RESPONSE_HOME_PAGE_CONTENT_ERROR':
      if (state[action.category].requestId !== action.requestId) return state;
      return {
        ...state,
        [action.category]: {
          ...state[action.category],
          fetching: false,
          error: true,
          content: [],
        },
      };
    // $FlowExpectedError
    case 'SIGN_OUT':
      /* We must clean all user and STB related data from store on sign-out */
      return {
        ...state,
        recommendations: {
          fetching: false,
          error: false,
          content: [],
          requestId: 0,
        },
        recently_watched: {
          fetching: false,
          error: false,
          content: [],
          requestId: 0,
        },
      };
    // $FlowExpectedError
    case 'CHANGE_ACTIVE_RECEIVER_SUCCESS':
      return {
        ...state,
        recently_watched: initialState.recently_watched,
      };
    // $FlowExpectedError
    case 'RECEIVE_SET_CURRENT_PROFILE_ID':
      return {
        ...state,
        recommendations: initialState.recommendations,
      };
    default:
      (action.type: empty); /* eslint-disable-line */
      return state;
  }
};

export default reducer;
